"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-ignore
const ky_1 = __importDefault(require("ky"));
const httpClient_1 = require("./httpClient");
const DEFAULT_TIMEOUT = 0;
const getInfoFromResponse = (response) => {
    var _a;
    return ({
        url: response === null || response === void 0 ? void 0 : response.url,
        responseStatus: response === null || response === void 0 ? void 0 : response.status,
        responseMessage: response === null || response === void 0 ? void 0 : response.statusText,
        location: (_a = response === null || response === void 0 ? void 0 : response.headers) === null || _a === void 0 ? void 0 : _a.get("location")
    });
};
const getInfoFromError = (error) => ({
    error: error.name,
    errorMessage: error === null || error === void 0 ? void 0 : error.message
});
const getInfoFromOptions = (options) => (Object.assign(Object.assign({ retryCount: options === null || options === void 0 ? void 0 : options.retryCount }, getInfoFromResponse(options === null || options === void 0 ? void 0 : options.response)), getInfoFromError(options === null || options === void 0 ? void 0 : options.error)));
const getKyHooks = (logFunction) => {
    return {
        beforeRetry: [
            (options) => {
                logFunction(`KY: beforeRetry hook: ${JSON.stringify(getInfoFromOptions(getInfoFromOptions(options)))}`);
            }
        ],
        afterResponse: [
            (request, options, response) => {
                logFunction(`KY: afterResponse hook: ${JSON.stringify(getInfoFromResponse(response))}`);
            }
        ]
    };
};
const getWithRetries = (url, headers, retryOptions, logFunction = () => { }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const retry = (0, httpClient_1.getRetryObject)(retryOptions, logFunction);
    let options = {
        retry: retry,
        hooks: getKyHooks(logFunction)
    };
    if (retryOptions.timeout) {
        options.timeout = retryOptions.timeout;
    }
    if (headers) {
        options.headers = headers;
    }
    try {
        const response = yield ky_1.default.get(url, options);
        const json = yield response.json();
        return {
            statusCode: response.status,
            body: json,
            headers: response.headers
        };
    }
    catch (e) {
        logFunction(`Error ${(_a = e.response) === null || _a === void 0 ? void 0 : _a.statusCode} in GET ${url}: ${e.message}`);
        throw e;
    }
});
const postWithRetries = (url, body, headers, retryOptions, logFunction = () => { }) => __awaiter(void 0, void 0, void 0, function* () {
    var _b;
    const retry = (0, httpClient_1.getRetryObject)(retryOptions, logFunction);
    let options = {
        json: body,
        retry: retry,
        hooks: getKyHooks(logFunction)
    };
    if (retryOptions.timeout) {
        options.timeout = retryOptions.timeout;
    }
    if (headers) {
        options.headers = headers;
    }
    try {
        const response = yield ky_1.default.post(url, options);
        const json = yield response.json();
        return {
            statusCode: response.status,
            body: json,
            headers: response.headers
        };
    }
    catch (e) {
        logFunction(`Error ${(_b = e.response) === null || _b === void 0 ? void 0 : _b.statusCode} in GET ${url}: ${e.message}`);
        throw e;
    }
});
const HttpClient = {
    DEFAULT_TIMEOUT,
    getWithRetries,
    postWithRetries
};
exports.default = HttpClient;
//# sourceMappingURL=browserHttpClient.js.map